module.exports = __webpack_public_path__ + "static/media/puzzle.44d063d8.png";